// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PushpinTwoToneSvg from "@ant-design/icons-svg/es/asn/PushpinTwoTone";
import AntdIcon from '../components/AntdIcon';

var PushpinTwoTone = function PushpinTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PushpinTwoToneSvg
  }));
};

PushpinTwoTone.displayName = 'PushpinTwoTone';
export default React.forwardRef(PushpinTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PushpinTwoTone.js
// module id = 1643
// module chunks = 0